import type { ComponentType } from "react";
import { useGetIdentity } from "ra-core";

import { AdvisorToday } from "./AdvisorToday";
import { DireccionPanel } from "./DireccionPanel";
import { LiderDashboard } from "./LiderDashboard";

/**
 * Almikia Epic E7 (TASK-089): the shared role-based home switch. An asesora
 * lands on "Hoy"; a Líder BPO lands on her team home (TASK-093); direccion
 * and a lead_manager land on the Dirección panel (TASK-094, same panel for
 * both -- a lead_manager's own RLS/brazo scope narrows every figure, and she
 * never sees the VoBo slot); every other role keeps `fallback` (today's
 * `Dashboard` / `MobileDashboard`) for good (ASSUMPTION: administracion,
 * compliance, contabilidad and auditoria keep the pre-E7 dashboard). Used
 * identically for both shells (`CRM.tsx`), so a future role branch is added
 * in exactly one place.
 *
 * See adr/ADR-ee2f59a9-TASK-089-role-based-home-switch.md
 */
export const RoleHome = ({
  fallback: Fallback,
}: {
  fallback: ComponentType;
}) => {
  const { identity, isPending } = useGetIdentity();
  if (isPending) return null;
  if (identity?.role === "asesora") return <AdvisorToday />;
  if (identity?.role === "lider") return <LiderDashboard />;
  if (identity?.role === "direccion" || identity?.role === "lead_manager") {
    return <DireccionPanel />;
  }
  return <Fallback />;
};
